export function notUndefined<T>(x: T | undefined): x is T {
  return x !== undefined;
}

export function notEmpty<T>(value: T | null | undefined): value is T {
  return value !== null && value !== undefined;
}
